import cn from 'classnames';
import React from 'react';
import {createUseStyles} from 'react-jss';

type Props = {
  title?: string
}

export default function NewSidePanel({
                                       title, children
                                     }: React.PropsWithChildren<Props>) {

  const styles = createUseStyles({
    width: {
      width: "27rem"
    }
  })();

  return (
    <>
      <div id="side-panel"
           className={cn('absolute right-0 top-0 order-1 min-h-full flex flex-col py-6 bg-white shadow-xl', styles.width)}>
        <div className="px-4 sm:px-6">
          <div className="flex items-start justify-between">
            <h2 id="slide-over-heading" className="text-lg font-medium">
              {title}
            </h2>
          </div>
        </div>
        <div className="mt-6 relative flex-1 px-8 flex flex-col items-start">
          <div className="w-full sticky top-8">
            {children}
          </div>
        </div>
      </div>
    </>
  );
}
